<script lang="ts">
	import type { CohortCourse } from '$lib/types/cohort-course';
	import {
		formatSessionLabel,
		formatSessionLocalLabel,
		type SessionLabelVariant
	} from '$lib/utils/calendar';

	// Session date/time label that localizes on hydration. The prerendered
	// fallback is the home timezone (IST) — deterministic, so prerender and
	// hydration agree — then swaps to the visitor's timezone, the same way
	// the currency selector localizes prices. variants:
	//   date "Mon, Oct 19" · time "7:00 PM IST" · full "Mon, Oct 19, 7:00 PM IST"
	let {
		cohort,
		variant = 'full'
	}: { cohort: CohortCourse['cohort']; variant?: SessionLabelVariant } = $props();

	let localLabel = $state<string | null>(null);

	$effect(() => {
		localLabel = formatSessionLocalLabel(cohort, variant);
	});
</script>

{#if localLabel}{localLabel}{:else}{formatSessionLabel(cohort, variant)}{/if}
